import { connect } from 'react-redux'
import cloneDeep from 'lodash/cloneDeep'
import { ICarrierState } from 'types/carrier'
import { updateCarrierInsurance as updateInsurance } from 'utils/actions/carrier'
import { closeEditInsuranceDialog as closeDialog } from 'apps/carrier/utils/actions/insurance'
import InsuranceDialogComponent from './InsuranceDialog'

interface IInsuranceDialogProps {
  carrier: ICarrierState
  carrierInsurance: any
  carrierInsuranceDialog: any
}

export const InsuranceDialog = connect(
  ({
    carrier: { carrierDetails: carrierData },
    carrierInsurance: { insurances },
    carrierInsuranceDialog: { showDialog, updateError, updating },
  }: IInsuranceDialogProps) => ({
    carrierId: carrierData ? carrierData.id : undefined,
    insurances: cloneDeep(insurances),
    updating,
    error: updateError,
    dialogOpen: showDialog,
  }),
  { updateInsurance, closeDialog }
  // @ts-ignore
)(InsuranceDialogComponent)
